import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogModel } from './dialog.model';

const selector = 'ols-notification-dialog';

@Component({
    selector: selector,
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogModel,
        private dialogRef: MatDialogRef<DialogComponent>
    ) {
        dialogRef.addPanelClass(`${selector}-panel`);
    }

    close(): void {
        this.dialogRef.close();
    }
}
